export const forceBrowserNavigation = (href: string): void => {
  if (typeof window === 'undefined' || !href) return;

  window.location.assign(href);
};
